import defaultAxios, { AxiosResponse } from 'axios'
import axios from './api'

import { GetMeType, RefreshInput, RefreshResponse, StatusResponse } from './account.types'

export type { GetMeType, StatusResponse }

/*
 * Fríska upp á innskráningu
 */
export const refresh = (data: RefreshInput): Promise<AxiosResponse<RefreshResponse>> => {
  return axios.post('/registration/refresh/', data, {
    requireAuth: false,
  })
}

/*
 * Sækja innskráðan notanda
 */
export const getMe = (): Promise<AxiosResponse<GetMeType>> => {
  return axios.get('/registration/me/')
}

/**
 * Vefþjónusta til þess að athuga með innskráningu.
 */
export const ping = (): Promise<AxiosResponse> => {
  return axios.get('/registration/ping/')
}

/**
 * Vefþjónusta til þess að athuga með skilaboð sem eru óháð gagnagrunni.
 */
export const status = (): Promise<AxiosResponse<StatusResponse[]>> => {
  return defaultAxios.get('/status/status.json')
}
